module.exports = __webpack_public_path__ + "eb2e6e3a3959f46e7d297b321a4f37c3.svg";